import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-300px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "px-7 py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Filter Options")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_4 = { class: "px-7 py-5" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Status:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  label: "Approved",
  value: "1"
}, "Approved", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  label: "Pending",
  value: "2"
}, "Pending", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  label: "In Process",
  value: "3"
}, "In Process", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  label: "Rejected",
  value: "4"
}, "Rejected", -1)
const _hoisted_11 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "mb-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Member Type:", -1)
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label user-select-none" }, " Author ", -1)
const _hoisted_17 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label user-select-none" }, " Customer ", -1)
const _hoisted_19 = { class: "mb-10" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Notifications:", -1)
const _hoisted_21 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }
const _hoisted_22 = { class: "form-check-label" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label user-select-none" }, "Enabled", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "reset",
    class: "btn btn-sm btn-white btn-active-light-primary me-2",
    "data-kt-menu-dismiss": "true"
  }, " Reset "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-sm btn-primary",
    "data-kt-menu-dismiss": "true"
  }, " Apply ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", null, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-solid select2-hidden-accessible",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.status) = $event))
          }, _hoisted_11, 512), [
            [_vModelSelect, _ctx.data.status]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: "1",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.author) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.data.author]
            ]),
            _hoisted_16
          ]),
          _createElementVNode("label", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              value: "2",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.customer) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.data.customer]
            ]),
            _hoisted_18
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              name: "notifications",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.notifications) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.data.notifications]
            ]),
            _hoisted_23
          ])
        ])
      ]),
      _hoisted_24
    ])
  ]))
}